"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const values_1 = require("../values");
/** What a steam express run walks: 0 = steam pressure, 1 = inlet temperature, 2 = inlet humidity. */
function propertyDefinition() {
    return [
        {
            sort_no: 2,
            name: "stepproperty",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: (0, values_1.integerValues)(3)
        }
    ];
}
//# sourceMappingURL=stepproperty-definition.js.map